// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__fqtRC","subheader":"ReorderModal_subheader__1WXGV","listWrap":"ReorderModal_listWrap__2dW6B"};